import React, { useState } from 'react';
import './AccessCodeModal.css';

const AccessCodeModal = ({ isOpen, onSubmit, onClose }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isValidating, setIsValidating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setError('Access Code를 입력해주세요.');
      return;
    }

    setIsValidating(true);
    setError('');

    try {
      const isValid = await onSubmit(code);
      if (!isValid) {
        setError('유효하지 않은 Access Code입니다.');
      }
    } catch (err) {
      setError('검증 중 오류가 발생했습니다.');
    } finally {
      setIsValidating(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="access-code-modal-overlay">
      <div className="access-code-modal">
        <div className="access-code-modal-header">
          <h2>🔐 Access Code 입력</h2>
          <p>FLUX 이미지 생성 서비스를 사용하려면 Access Code가 필요합니다.</p>
        </div>

        <form onSubmit={handleSubmit} className="access-code-form">
          <div className="form-group">
            <label htmlFor="accessCode">Access Code</label>
            <input
              id="accessCode"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Access Code를 입력하세요"
              autoFocus
              disabled={isValidating}
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <div className="access-code-modal-footer">
            <button
              type="submit"
              className="submit-btn"
              disabled={isValidating}
            >
              {isValidating ? '검증 중...' : '확인'}
            </button>
            {onClose && (
              <button
                type="button"
                className="cancel-btn"
                onClick={onClose}
                disabled={isValidating}
              >
                취소
              </button>
            )}
          </div>
        </form>

        <div className="access-code-hint">
          <p>💡 힌트: 기본 Access Code는 <code>gategil1149</code>입니다.</p>
        </div>
      </div>
    </div>
  );
};

export default AccessCodeModal;